/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('spannerSourceEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./spanner-source-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: ['$scope', function ($scope) {}],
    };
  },
]);
